import './layout/salesChannelSelector';
import './layout/fixCustomizationGiftcard';
import './layout/shadowHeader';
import './layout/fixedBreadCrumb';
import './layout/megamenu';
import './widgets/user';
import './widgets/search';
import './layout/shelf';
import './layout/modalInfoVariations';
import './widgets/buy-qnt';
import './widgets/cart';
import './layout/addColorToShelfTile';
import './layout/reciple';
import './widgets/whatsappFixedBtn';
import './layout/fixCallCenterToolbar';
import './layout/alertDownloadApp';
import './layout/dynamicShelf';
import './widgets/copy-cupom-header';
import './widgets/alertRemoveCardMyAccount';
import './rnk-promotion';

console.log('🧩 window.storeTheme', window.storeTheme);
